module.exports = __webpack_public_path__ + "img/coupon-item-shade.49778aaf.png";